import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import { type ApiError, type ApiResponse, useAxiosInstance } from './utils';
import { addActionNameToMutationResult } from './utils/add-action-name-to-mutation-result';

export type DeletePaymentVariables = {
  id: number;
  type: string;
};

export async function deletePaymentFn(
  axiosInstance: Promise<AxiosInstance>,
  variables: DeletePaymentVariables,
): Promise<ApiResponse> {
  const { id, type } = variables;
  const instance = await axiosInstance;

  return instance.delete(`payments/${id}`, {
    params: { type },
  });
}

export function useDeletePayment() {
  const client = useQueryClient();
  const axiosInstance = useAxiosInstance();

  const mutation = useMutation<ApiResponse, ApiError, DeletePaymentVariables>({
    mutationFn: variables => deletePaymentFn(axiosInstance, variables),
    onSuccess: () => {
      client.invalidateQueries({ queryKey: ['payments'] });
    },
  });

  return addActionNameToMutationResult<
    ApiResponse,
    ApiError,
    DeletePaymentVariables,
    'deletePayment'
  >('deletePayment', mutation);
}
